'use client'

import { useEffect, useRef, useState } from 'react'

export type ScrollDirection = 'scrolling up' | 'scrolling down'

const SCROLL_THRESHOLD = 5

function getScrollY(): number {
  if (typeof globalThis === 'undefined') return 0
  return globalThis.scrollY ?? globalThis.pageYOffset ?? 0
}

function useCatchScroll() {
  const [scrollDir, setScrollDir] = useState<ScrollDirection>('scrolling down')
  const lastScrollYRef = useRef<number>(0)

  useEffect(() => {
    if (typeof globalThis === 'undefined') return

    lastScrollYRef.current = getScrollY()

    const handleScroll = () => {
      const currentScrollY = getScrollY()
      const diff = currentScrollY - lastScrollYRef.current

      if (Math.abs(diff) < SCROLL_THRESHOLD) return

      setScrollDir(diff > 0 ? 'scrolling down' : 'scrolling up')
      lastScrollYRef.current = currentScrollY
    }

    globalThis.addEventListener('scroll', handleScroll, { passive: true })
    return () => globalThis.removeEventListener('scroll', handleScroll)
  }, [])

  return { scrollDir }
}

/** Named export */
export { useCatchScroll }

/** Default export */
export default useCatchScroll
